import { WebApiService } from '../../../plugins/webApiService'
import { Events } from '../../../plugins/events'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import ProfileEditRequest from '../../../users/profile/i-service/models/ProfileEditRequest';
import ContactEditRequest from '../../../users/profile/i-service/models/ContactEditRequest';
import ProfileRemoveRequest from '../../../users/profile/i-service/models/ProfileRemoveRequest';
import ContactGetRequest from '../../../users/profile/i-service/models/ContactGetRequest';
import ProfileGetRequest from '../../../users/profile/i-service/models/ProfileGetRequest';
import AttachFileUsersRequest from '../../../users/profile/i-service/models/request/AttachFileUsersRequest';
import GetFilesUserRequest from '../../../users/profile/i-service/models/request/GetFilesUserRequest';
import RemoveFilesUsersRequest from '../../../users/profile/i-service/models/request/RemoveFilesUsersRequest';
import WsResponseModelT from '../../../schema-builder-server/models/WsResponseModelT';
import ProfileResponse from '../../../users/profile/i-service/models/ProfileResponse';
import ProfileContactResponse from '../../../users/profile/i-service/models/ProfileContactResponse';
import ShortProfile from '../../../users/profile/i-service/models/ShortProfile';
import FilePageResponse from '../../../files/interfaces/models/response/FilePageResponse';

export default class UsersProfileService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	EditProfileEvent = new Events<WsResponseModelT<ProfileResponse>>();
	EditProfileContactEvent = new Events<WsResponseModelT<ProfileContactResponse>>();
	RemoveProfileEvent = new Events<WsResponseModelT<Boolean>>();
	GetAllProfileEvent = new Events<WsResponseModelT<Array<ProfileResponse>>>();
	GetProfileContactEvent = new Events<WsResponseModelT<ProfileContactResponse>>();
	GetProfileEvent = new Events<WsResponseModelT<ProfileResponse>>();
	GetShortProfileEvent = new Events<WsResponseModelT<Array<ShortProfile>>>();
	GetUserProfileServiceEvent = new Events<WsResponseModelT<Array<ProfileResponse>>>();
	UserAddFileEvent = new Events<WsResponseModelT<Boolean>>();
	UserGetFilesEvent = new Events<WsResponseModelT<FilePageResponse>>();
	UserRemoveFilesEvent = new Events<WsResponseModelT<Boolean>>();
	GetPerformerServiceEvent = new Events<WsResponseModelT<Array<ShortProfile>>>();
	SearchUsersIdsEvent = new Events<WsResponseModelT<Array<number>>>();
	GetUsersByIdsEvent = new Events<WsResponseModelT<Array<ShortProfile>>>();

	subscribeEvents = async () => {
		const self = this;
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		webApiService.on('UsersProfileService', 'EditProfile', 'Main', (res: WsResponseModelT<ProfileResponse>) => {
			self.EditProfileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'EditProfileContact', 'Main', (res: WsResponseModelT<ProfileContactResponse>) => {
			self.EditProfileContactEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'RemoveProfile', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.RemoveProfileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetAllProfile', 'Main', (res: WsResponseModelT<Array<ProfileResponse>>) => {
			self.GetAllProfileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetProfileContact', 'Main', (res: WsResponseModelT<ProfileContactResponse>) => {
			self.GetProfileContactEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetProfile', 'Main', (res: WsResponseModelT<ProfileResponse>) => {
			self.GetProfileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetShortProfile', 'Main', (res: WsResponseModelT<Array<ShortProfile>>) => {
			self.GetShortProfileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetUserProfileService', 'Main', (res: WsResponseModelT<Array<ProfileResponse>>) => {
			self.GetUserProfileServiceEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'UserAddFile', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UserAddFileEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'UserGetFiles', 'Main', (res: WsResponseModelT<FilePageResponse>) => {
			self.UserGetFilesEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'UserRemoveFiles', 'Main', (res: WsResponseModelT<Boolean>) => {
			self.UserRemoveFilesEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetPerformerService', 'Main', (res: WsResponseModelT<Array<ShortProfile>>) => {
			self.GetPerformerServiceEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'SearchUsersIds', 'Main', (res: WsResponseModelT<Array<number>>) => {
			self.SearchUsersIdsEvent.trigger(res);
		});
		webApiService.on('UsersProfileService', 'GetUsersByIds', 'Main', (res: WsResponseModelT<Array<ShortProfile>>) => {
			self.GetUsersByIdsEvent.trigger(res);
		});
	}

	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
		this.subscribeEvents();
	}

	/**
	 * * изменить профиль пользователя
	 */
	async EditProfile(request: ProfileEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'EditProfile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * изменить контакты в профиле пользователя
	 */
	async EditProfileContact(request: ContactEditRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'EditProfileContact',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить профиль пользователя
	 */
	async RemoveProfile(request: ProfileRemoveRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'RemoveProfile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить все профили пользователей
	 */
	async GetAllProfile() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetAllProfile',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * получить контакты из профиля пользователя
	 */
	async GetProfileContact(request: ContactGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetProfileContact',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить информацыю о пользователе
	 */
	async GetProfile(request: ProfileGetRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetProfile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async GetShortProfile() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetShortProfile',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список пользователйе для сервисов
	 */
	async GetUserProfileService(userIdList: Array<number>) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetUserProfileService',
			Value: typeof(userIdList) === 'object' ? JSON.stringify(userIdList) : userIdList,
		})

		webApiService.send(sendRequest);
	}

	async UserAddFile(request: AttachFileUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'UserAddFile',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить файлы пользователя
	 */
	async UserGetFiles(request: GetFilesUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'UserGetFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async UserRemoveFiles(request: RemoveFilesUsersRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'UserRemoveFiles',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Список работников
	 */
	async GetPerformerService() {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetPerformerService',
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить айди пользователей по текстовому запросу
	 */
	async SearchUsersIds(search: string) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'SearchUsersIds',
			Value: typeof(search) === 'object' ? JSON.stringify(search) : search,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список пользователей по айди
	 */
	async GetUsersByIds(ids: Array<number>) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'UsersProfileService',
			Method: 'GetUsersByIds',
			Value: typeof(ids) === 'object' ? JSON.stringify(ids) : ids,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * изменить профиль пользователя
	 */
	async editProfileAsync(request: ProfileEditRequest): Promise<ProfileResponse> {
		return new Promise<ProfileResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'EditProfile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProfileResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProfileResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * изменить контакты в профиле пользователя
	 */
	async editProfileContactAsync(request: ContactEditRequest): Promise<ProfileContactResponse> {
		return new Promise<ProfileContactResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'EditProfileContact',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProfileContactResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProfileContactResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить профиль пользователя
	 */
	async removeProfileAsync(request: ProfileRemoveRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'RemoveProfile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить все профили пользователей
	 */
	async getAllProfileAsync(): Promise<Array<ProfileResponse>> {
		return new Promise<Array<ProfileResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetAllProfile',
				Callback: (response: WsResponseModelT<Array<ProfileResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ProfileResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * получить контакты из профиля пользователя
	 */
	async getProfileContactAsync(request: ContactGetRequest): Promise<ProfileContactResponse> {
		return new Promise<ProfileContactResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetProfileContact',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProfileContactResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProfileContactResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить информацыю о пользователе
	 */
	async getProfileAsync(request: ProfileGetRequest): Promise<ProfileResponse> {
		return new Promise<ProfileResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetProfile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<ProfileResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as ProfileResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей и краткую информацыю о них
	 */
	async getShortProfileAsync(): Promise<Array<ShortProfile>> {
		return new Promise<Array<ShortProfile>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetShortProfile',
				Callback: (response: WsResponseModelT<Array<ShortProfile>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ShortProfile>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список пользователйе для сервисов
	 */
	async getUserProfileServiceAsync(userIdList: Array<number>): Promise<Array<ProfileResponse>> {
		return new Promise<Array<ProfileResponse>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetUserProfileService',
				Value: typeof(userIdList) === 'object' ? JSON.stringify(userIdList) : userIdList,
				Callback: (response: WsResponseModelT<Array<ProfileResponse>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ProfileResponse>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	async userAddFileAsync(request: AttachFileUsersRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'UserAddFile',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить файлы пользователя
	 */
	async userGetFilesAsync(request: GetFilesUserRequest): Promise<FilePageResponse> {
		return new Promise<FilePageResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'UserGetFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<FilePageResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as FilePageResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Удалить файлы пользователя
	 */
	async userRemoveFilesAsync(request: RemoveFilesUsersRequest): Promise<Boolean> {
		return new Promise<Boolean>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'UserRemoveFiles',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<Boolean>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Boolean)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Список работников
	 */
	async getPerformerServiceAsync(): Promise<Array<ShortProfile>> {
		return new Promise<Array<ShortProfile>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetPerformerService',
				Callback: (response: WsResponseModelT<Array<ShortProfile>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ShortProfile>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить айди пользователей по текстовому запросу
	 */
	async searchUsersIdsAsync(search: string): Promise<Array<number>> {
		return new Promise<Array<number>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'SearchUsersIds',
				Value: typeof(search) === 'object' ? JSON.stringify(search) : search,
				Callback: (response: WsResponseModelT<Array<number>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<number>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список пользователей по айди
	 */
	async getUsersByIdsAsync(ids: Array<number>): Promise<Array<ShortProfile>> {
		return new Promise<Array<ShortProfile>>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'UsersProfileService',
				Method: 'GetUsersByIds',
				Value: typeof(ids) === 'object' ? JSON.stringify(ids) : ids,
				Callback: (response: WsResponseModelT<Array<ShortProfile>>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as Array<ShortProfile>)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}